<template>
  <div class="fill-height overflow-x-hidden" :class="smAndDown ? 'background-mob' : 'background'" :style="`background-image: ${splash}`">
    <v-row class="ma-0  fill-height">
      <v-col cols="12">
        <v-row justify="start" class="position-fixed ">
          <v-col cols="auto">
            <v-img :src="landscapeLogoSrc" :width="smAndDown ? 200 : 250" :max-width="smAndDown ? 200 : 250" class="py-2 mx-2 float-right"/>
          </v-col>
        </v-row>
        <v-row class="fill-height" justify="center" align="center" style="width: 100%">
          <v-col cols="12">
            <v-stepper @update:modelValue="activeStep = $event" :model-value="activeStep" flat class="my-auto" id="login-stepper" @change="error = ''" min-width="400">
              <v-stepper-window :model-value="activeStep">
                <v-stepper-window-item :value="LoginSteps.EmailPrompt" class="fill-height">
                  <v-row class="fill-height" justify="center" align="center" no-gutters>
                    <v-col cols="12" md="6">
                      <EmailPrompt @checkEmail="username = $event; checkUser();" :loading="loading" :error="error" @clearError="error = ''" :query-username="username"/>
                    </v-col>
                  </v-row>
                </v-stepper-window-item>
                <v-stepper-window-item :value="LoginSteps.PasswordPrompt" class="fill-height">
                  <v-row class="fill-height" justify="center" align="center" no-gutters>
                    <v-col cols="12" md="6">
                      <PasswordPrompt
                          :activated="activated"
                          :error="error"
                          :query-code="queryCode"
                          @clearError="error = ''"
                          @goToEmail="activeStep = LoginSteps.EmailPrompt"
                          @checkPassword="password = $event; login()"
                          @goToForgotPassword="activeStep = LoginSteps.ForgotPassword"
                          @goToResendRegistration="activeStep = LoginSteps.ResendRegistration"
                      />
                    </v-col>
                  </v-row>
                </v-stepper-window-item>
                <v-stepper-window-item :value="LoginSteps.NewPasswordPrompt" class="fill-height">
                  <v-row class="fill-height" justify="center" align="center" no-gutters>
                    <v-col cols="12" md="6">
                      <PasswordPrompt
                          :error="error"
                          @clearError="error = ''"
                          @goToEmail="activeStep = LoginSteps.EmailPrompt"
                          @checkPassword="password = $event; login()"
                          :loading="loading"
                          :activated="activated"
                          :is-new="isNew"
                      />
                    </v-col>
                  </v-row>
                </v-stepper-window-item>
                <v-stepper-window-item :value="LoginSteps.ForgotPassword" class="fill-height">
                  <v-row class="fill-height" justify="center" align="center" no-gutters>
                    <v-col cols="12" md="6">
                      <ResendPrompt :username="username" @go-to:email="activeStep = LoginSteps.EmailPrompt"/>
                    </v-col>
                  </v-row>
                </v-stepper-window-item>
                <v-stepper-window-item :value="LoginSteps.ResendRegistration" class="fill-height">
                  <v-row class="fill-height" justify="center" align="center" no-gutters>
                    <v-col cols="12" md="6">
                      <ResendPrompt :username="username" :activating="true" @go-to:email="activeStep = LoginSteps.EmailPrompt"/>
                    </v-col>
                  </v-row>
                </v-stepper-window-item>
                <v-stepper-window-item :value="LoginSteps.Loading" class="fill-height">
                  <v-row class="fill-height" justify="center" align="center" no-gutters>
                    <v-col cols="12" md="6">
                      <v-row justify="center" align="center">
                        <v-col cols="12" md="5" class="pa-4">
                          <v-card color="background" class="px-4 py-6">
                            <v-row no-gutters align="center" justify="center">
                              <v-col cols="12" class="text-center">
                                <span class="text-h5 font-weight-bold">Logging you in..</span>
                              </v-col>
                              <v-col cols="auto" class="mt-6">
                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-stepper-window-item>
              </v-stepper-window>
            </v-stepper>
          </v-col>
        </v-row>

      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import {Component, Vue, toNative, Watch} from "vue-facing-decorator";
import EmailPrompt from "@/views/login/EmailPrompt.vue";
import PasswordPrompt from "@/views/login/PasswordPrompt.vue";
import LoginService from "@/services/login.service";
import ResendPrompt from "@/views/login/ResendPrompt.vue";
import { LoginResponse } from "../../types";
import { useDisplay } from 'vuetify';
import { useUserStore } from "@/stores/userStore";
import {getPublicContentURl} from "@/util";

enum LoginSteps {
  EmailPrompt = 0,
  PasswordPrompt = 1,
  NewPasswordPrompt = 2,
  ForgotPassword = 3,
  ResendRegistration = 4,
  Loading = 5
}

@Component({
  name: 'login',
  components: {ResendPrompt, PasswordPrompt, EmailPrompt}
})
export default class LoginFlow extends Vue {
  private LoginSteps = LoginSteps;
  private activeStep = LoginSteps.EmailPrompt;
  private loginData: LoginResponse = {};
  private loading = false;
  private activated = false;
  private activating = false;
  private challenged = false;
  private isNew = false;
  private username = '';
  private password = '';
  private queryCode = '';
  private error = '';
  private smAndDown = useDisplay().smAndDown;
  private splash: any = `url(${getPublicContentURl('themes/splash.png')})`

  @Watch('smAndDown', {immediate: true})
  private onDisplayChange() {
    this.updateBackgroundImage();
  }

  private mounted() {
    if (this.$route.query.username) {
      this.username = this.$route.query.username.toString();
      if (this.$route.query.code) {
        this.queryCode = this.$route.query.code.toString();
      }

    }
  }

  private loadSplash(url: string) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(url);
      img.onerror = () => reject();
      img.src = url;
    });
  }

  private updateBackgroundImage() {
    if (this.smAndDown) {
      this.loadSplash(getPublicContentURl('themes/splash_mobile.png'))
          .then(url => {
            this.splash = url;
          })
          .catch(() => {
            this.splash = `url(${getPublicContentURl('themes/splash.png')})`;
          });
    } else {
      this.splash = `url(${getPublicContentURl('themes/splash.png')})`;
    }
  }

  private async checkUser() {
    this.loading = true;
    this.challenged = false;
    try {
      const userStatus = await LoginService.getUserStatus(this.username);
      switch (userStatus.status) {
        case 'FORCE_CHANGE_PASSWORD':
          this.activated = false;
          this.isNew = true;
          this.activeStep = LoginSteps.PasswordPrompt;
          break;
        case 'UNCONFIRMED':
          this.activated = false;
          this.isNew = false;
          this.activeStep = LoginSteps.PasswordPrompt;
          break;
        case 'OK':
        default:
          this.activated = true;
          this.isNew = false;
          this.activeStep = LoginSteps.PasswordPrompt;
          break;
      }
    } catch (err) {
      this.error = (err as Error).message;
    } finally {
      this.loading = false;
    }
  }

  private async login() {
    this.loading = true
    const oldStep: LoginSteps = this.activeStep;
    this.activeStep = LoginSteps.Loading;
    try {
      if (this.challenged) {
        await this.respondToAuthChallenge(this.loginData);
        return;
      }
      const loginResponse = this.activated ?
        await LoginService.login({username: this.username, password: this.password}) :
        await LoginService.register({username: this.username, code: this.password});
      if (loginResponse.challenge === 'NEW_PASSWORD_REQUIRED') {
        this.challenged = true;
        this.activated = false;
        this.isNew = true;
        this.loginData = loginResponse;
        this.activeStep = LoginSteps.NewPasswordPrompt;
        return;
      }
      if (loginResponse.token) {
        await this.loginSuccess(loginResponse.token);
      }
    } catch (err) {
      this.error = (err as Error).message;
      this.activeStep = oldStep;
    } finally {
      this.loading = false;
    }
  }

  private async respondToAuthChallenge(loginResponse: LoginResponse): Promise<void> {
    this.activeStep = LoginSteps.Loading;
    try {
      const response = await LoginService.respond({
        username: this.username,
        newPassword: this.password,
        challenge: 'NEW_PASSWORD_REQUIRED',
        session: loginResponse.session ? loginResponse.session : '',
        requiredAttributes: loginResponse.requiredAttributes || []
      });
      if (response.challenge) {
        throw new Error(`Unexpected challenge response encountered ${response.challenge}`);
      }
      if (response.token) {
        await this.loginSuccess(response.token);
      }
    } catch (err) {
      this.error = (err as Error).message;
      this.challenged = false;
      this.activeStep = LoginSteps.PasswordPrompt;
    }
  }

  private get landscapeLogoSrc() {
   return getPublicContentURl('themes/default.png');
  }

  private async loginSuccess(JWT: string) {
    await useUserStore().userLogin(JWT);
  }
}
</script>

<style>
  #login-stepper {
    background-color: transparent;
  }
  #login-stepper .v-stepper__wrapper {
    height: 100% !important;
  }
  .centered {
    height: 100%;
  }
  .background {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .background-mob {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .z99 {
    z-index: 99;
  }
  .center {
    transform: translateX(calc(100vw - 75%));
  }

</style>